﻿/* Each item in this array is a Product Material. Some of the properties:
 * Width-/HeightStrategy: defines how the application should scale/crop the image.
 * ProductWidth/-Height: units are millimeters. TODO: Rename to MaterialWidth/-Height
 *
 * A 'material' is a product finish as used on the surface of a product or component. The same finish
 * might be used with multiple materials. The finishes might the look the same, or they might have
 * minor differences.
 *
 * Material specific items are listed first as seen by the Id's prefix. Generic finishes are listed
 * at the end. These finishes will be used if a more specific material item is not found.
 */
export const ProductMaterialsMap = [
  {
    'id': 'AluFlatDivider-BlackAluminum',
    'fileName': 'AluFlatDivider-BlackAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 849.29896907216494,
    'productHeight': 34.0
  },
  {
    'id': 'AluFlatDivider-BrassAluminum',
    'fileName': 'AluFlatDivider-BrassAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 618.07142857142856,
    'productHeight': 34.0
  },
  {
    'id': 'AluFlatDivider-NaturalAluminum',
    'fileName': 'AluFlatDivider-NaturalAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 988.17021276595733,
    'productHeight': 34.0
  },
  {
    'id': 'AluFlatDivider-WhiteAluminum',
    'fileName': 'AluFlatDivider-WhiteAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 518.68085106382966,
    'productHeight': 34.0
  },
  {
    'id': 'AluHDivider-BlackAluminum',
    'fileName': 'AluHDivider-BlackAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.16071428571433,
    'productHeight': 34.0
  },
  {
    'id': 'AluHDivider-BrassAluminum',
    'fileName': 'AluHDivider-BrassAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.132075471698,
    'productHeight': 34.0
  },
  {
    'id': 'AluHDivider-NaturalAluminum',
    'fileName': 'AluHDivider-NaturalAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.04566210045664,
    'productHeight': 34.0
  },
  {
    'id': 'AluHDivider-WhiteAluminum',
    'fileName': 'AluHDivider-WhiteAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.1,
    'productHeight': 34.0
  },
  {
    'id': 'AsurDoorRail-BronzeSteel',
    'fileName': 'AsurDoorRail-BronzeSteel.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 739.44086021505382,
    'productHeight': 16.0
  },
  {
    'id': 'AsurDoorRail-SilverSteel',
    'fileName': 'AsurDoorRail-SilverSteel.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 740.47311827956992,
    'productHeight': 16.0
  },
  {
    'id': 'AsurDoorRail-WhiteSteel',
    'fileName': 'AsurDoorRail-WhiteSteel.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 740.81720430107544,
    'productHeight': 16.0
  },
  {
    'id': 'AsurDoorStile-BronzeSteel',
    'fileName': 'AsurDoorStile-BronzeSteel.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 20.5,
    'productHeight': 2049.9999999999995
  },
  {
    'id': 'AsurDoorStile-SilverSteel',
    'fileName': 'AsurDoorStile-SilverSteel.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 20.5,
    'productHeight': 2062.9473684210525
  },
  {
    'id': 'AsurDoorStile-WhiteSteel',
    'fileName': 'AsurDoorStile-WhiteSteel.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 20.5,
    'productHeight': 2059.3508771929824
  },
  {
    'id': 'DoorPanel-AntrasiteMelamine',
    'fileName': 'DoorPanel-AntrasiteMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 530.19334389857374,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-ArabesqueBlackMelamine',
    'fileName': 'DoorPanel-ArabesqueBlackMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1036.9047254931948,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-ArabesqueWhiteMelamine',
    'fileName': 'DoorPanel-ArabesqueWhiteMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 959.01390282356317,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BambooBrownVeneer',
    'fileName': 'DoorPanel-BambooBrownVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1255.8131537469553,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BirchMelamine',
    'fileName': 'DoorPanel-BirchMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BirchVeneer',
    'fileName': 'DoorPanel-BirchVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-Black_NCS_S9000N',
    'fileName': 'DoorPanel-Black_NCS_S9000N.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 960.35938903863439,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BlackGlass',
    'fileName': 'DoorPanel-BlackGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002
  },
  {
    'id': 'DoorPanel-BlackOakPaint',
    'fileName': 'DoorPanel-BlackOakPaint.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 949.52905198776762,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BlackSilk',
    'fileName': 'DoorPanel-BlackSilk.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1212.7860613168034,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BronzeMirror',
    'fileName': 'DoorPanel-BronzeMirror.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002,
    'useStretch': true
  },
  {
    'id': 'DoorPanel-BrownGlass',
    'fileName': 'DoorPanel-BrownGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BrownMelamine',
    'fileName': 'DoorPanel-BrownMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1036.6278356836297,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-BrushedAluminumMelamine',
    'fileName': 'DoorPanel-BrushedAluminumMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1220.0,
    'productHeight': 2440.0
  },
  {
    'id': 'DoorPanel-CashmereXT',
    'fileName': 'DoorPanel-CashmereXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 617.60190703218109,
    'productHeight': 2280.0
  },
  {
    'id': 'DoorPanel-CherryMelamine',
    'fileName': 'DoorPanel-CherryMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-CherryVeneer',
    'fileName': 'DoorPanel-CherryVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1203.2697237254345,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-ClearGlass',
    'fileName': 'DoorPanel-ClearGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002
  },
  {
    'id': 'DoorPanel-ClearMirror',
    'fileName': 'DoorPanel-ClearMirror.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002,
    'useStretch': true
  },
  {
    'id': 'DoorPanel-CottagePine',
    'fileName': 'DoorPanel-CottagePine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 965.83397982932513,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-Driftwood',
    'fileName': 'DoorPanel-Driftwood.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1866.7636363636366,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-GrayGlass',
    'fileName': 'DoorPanel-GrayGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002
  },
  {
    'id': 'DoorPanel-GrayMirror',
    'fileName': 'DoorPanel-GrayMirror.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1206.9750889679717,
    'productHeight': 2440.0,
    'useStretch': true
  },
  {
    'id': 'DoorPanel-GrayNCS_S5500N',
    'fileName': 'DoorPanel-GrayNCS_S5500N.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1204.0806642941875,
    'productHeight': 2440.0
  },
  {
    'id': 'DoorPanel-GrayReed',
    'fileName': 'DoorPanel-GrayReed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 959.33550875111234,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-GraySilk',
    'fileName': 'DoorPanel-GraySilk.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1210.7086614173229,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-HorizonXT',
    'fileName': 'DoorPanel-HorizonXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 613.89503862387517,
    'productHeight': 2280.0
  },
  {
    'id': 'DoorPanel-LavaElm',
    'fileName': 'DoorPanel-LavaElm.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 958.13809154383239,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-Lavender_NCS_S1020N_R40B',
    'fileName': 'DoorPanel-Lavender_NCS_S1020N_R40B.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1018.488733972364,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-LightGrayReed',
    'fileName': 'DoorPanel-LightGrayReed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 947.23558313938452,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-LightGreyXT',
    'fileName': 'DoorPanel-LightGreyXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 785.357715752326,
    'productHeight': 2280.0
  },
  {
    'id': 'DoorPanel-MahognyVeneerStained',
    'fileName': 'DoorPanel-MahognyVeneerStained.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-ManhattanGrayMelamine',
    'fileName': 'DoorPanel-ManhattanGrayMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1240.0,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-MilanWalnutMelamine',
    'fileName': 'DoorPanel-MilanWalnutMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1240.0,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakCountryMelamine',
    'fileName': 'DoorPanel-OakCountryMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1240.0,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakDarkMelamine',
    'fileName': 'DoorPanel-OakDarkMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakMelamine',
    'fileName': 'DoorPanel-OakMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakPearlMelamine',
    'fileName': 'DoorPanel-OakPearlMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakReed',
    'fileName': 'DoorPanel-OakReed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 960.70907194994788,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakVeneer',
    'fileName': 'DoorPanel-OakVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakWhiteMelamine',
    'fileName': 'DoorPanel-OakWhiteMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-OakWhiteVeneer',
    'fileName': 'DoorPanel-OakWhiteVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1200.4670472236637,
    'productHeight': 3300.0
  },
  {
    'id': 'DoorPanel-PineVeneer',
    'fileName': 'DoorPanel-PineVeneer.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 776.6972477064221,
    'productHeight': 2040.0
  },
  {
    'id': 'DoorPanel-PineWood',
    'fileName': 'DoorPanel-PineWood.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 657.46478873239437,
    'productHeight': 2040.0
  },
  {
    'id': 'DoorPanel-PineWoodLacker',
    'fileName': 'DoorPanel-PineWoodLacker.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 657.46478873239437,
    'productHeight': 2040.0
  },
  {
    'id': 'DoorPanel-PineWoodProvence',
    'fileName': 'DoorPanel-PineWoodProvence.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 657.46478873239437,
    'productHeight': 2040.0
  },
  {
    'id': 'DoorPanel-Powder',
    'fileName': 'DoorPanel-Powder.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 576.4798118384947,
    'productHeight': 2280.0
  },
  {
    'id': 'DoorPanel-SanRemoSandOak',
    'fileName': 'DoorPanel-SanRemoSandOak.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 953.9694853891906,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-SeaWeed',
    'fileName': 'DoorPanel-SeaWeed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1059.5933926302414,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-StoneAsh',
    'fileName': 'DoorPanel-StoneAsh.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 959.73931178310738,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-Taupe_NCS_S6005_Y20R',
    'fileName': 'DoorPanel-Taupe_NCS_S6005_Y20R.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 969.236031927024,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-VolcanicBlackXT',
    'fileName': 'DoorPanel-VolcanicBlackXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 586.99728910859517,
    'productHeight': 2280.0
  },
  {
    'id': 'DoorPanel-WhiteEmbossedReed',
    'fileName': 'DoorPanel-WhiteEmbossedReed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 954.950994950995,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-WhiteGlass',
    'fileName': 'DoorPanel-WhiteGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1198.6499999999999,
    'productHeight': 2440.0,
    'useStretch': true
  },
  {
    'id': 'DoorPanel-WhiteMelamine',
    'fileName': 'DoorPanel-WhiteMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-WhiteMelamineReed',
    'fileName': 'DoorPanel-WhiteMelamineReed.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 957.1606771606771,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-WhiteNCS_S0500N',
    'fileName': 'DoorPanel-WhiteNCS_S0500N.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0
  },
  {
    'id': 'DoorPanel-WhiteProfileMelamine',
    'fileName': 'DoorPanel-WhiteProfileMelamine.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 761.56861489191351,
    'productHeight': 2796.0
  },
  {
    'id': 'DoorPanel-WhiteProfilePaint',
    'fileName': 'DoorPanel-WhiteProfilePaint.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 715.12350597609566,
    'productHeight': 2268.0
  },
  {
    'id': 'EdgeDoorStile-BlackAluminum',
    'fileName': 'EdgeDoorStile-BlackAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 451.764705882353
  },
  {
    'id': 'EdgeDoorStile-NaturalAluminum',
    'fileName': 'EdgeDoorStile-NaturalAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 451.764705882353
  },
  {
    'id': 'EdgeDoorStile-WhiteAluminum',
    'fileName': 'EdgeDoorStile-WhiteAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 457.14285714285717
  },
  {
    'id': 'EdgeHDivider-BlackAluminum',
    'fileName': 'EdgeHDivider-BlackAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 381.1332633788038,
    'productHeight': 26.0
  },
  {
    'id': 'EdgeHDivider-NaturalAluminum',
    'fileName': 'EdgeHDivider-NaturalAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 381.1332633788038,
    'productHeight': 26.0
  },
  {
    'id': 'EdgeHDivider-WhiteAluminum',
    'fileName': 'EdgeHDivider-WhiteAluminum.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 377.73125000000005,
    'productHeight': 26.0
  },

  /* **** EDGE MATERIALS **** */
   // TODO: All Edge materials must be updated with correct images and specs!!!
  {
    'id': 'EdgeDoorRail-BlackAluminum',
    'fileName': 'SafirBottomDoorRail-BlackAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0,
  },
  {
    'id': 'EdgeDoorRail-NaturalAluminum',
    'fileName': 'SafirBottomDoorRail-NaturalAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 471.18055555555554,
    'productHeight': 50.0,
  },
  {
    'id': 'EdgeDoorRail-WhiteAluminum',
    'fileName': 'SafirBottomDoorRail-WhiteAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0,
  },

  {
    'id': 'FlexiDrawer-BirchMelamine',
    'fileName': 'FlexiDrawer-BirchMelamine.jpg',
    'productType': 'Drawer',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 883.60498561840836,
    'productHeight': 480.0
  },
  {
    'id': 'FlexiDrawer-MahognyVeneerStained',
    'fileName': 'FlexiDrawer-MahognyVeneerStained.jpg',
    'productType': 'Drawer',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 879.38931297709928,
    'productHeight': 480.0
  },
  {
    'id': 'FlexiDrawer-OakMelamine',
    'fileName': 'FlexiDrawer-OakMelamine.jpg',
    'productType': 'Drawer',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 881.07074569789677,
    'productHeight': 480.0
  },
  {
    'id': 'FlexiShelf-OakWhiteMelamine',
    'fileName': 'FlexiShelf-OakWhiteMelamine.jpg',
    'productType': 'FlexiShelf',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 880,
    'productHeight': 500,
  },
  // TODO: Create optimized images for the Black flexi-shelf like we've done with the FlexiShelf-OakWhiteMelamine
  {
    'id': 'FlexiShelf-Black_NCS_S9000N',
    'fileName': 'DoorPanel-Black_NCS_S9000N.jpg',
    'productType': 'FlexiShelf',
    'rotation': 90.0,
    // Because we're rotating the image, we need to swap productWidth and -Height
    'productHeight': 952.65597147950086,
    'productWidth': 2480.0,
    'heightStrategy': 'Crop',
    'widthStrategy': 'Proportional',
  },
  {
    'id': 'TopShelf-OakWhiteMelamine',
    'fileName': 'DoorPanel-OakWhiteMelamine.jpg',
    'productType': 'TopShelf',
    'rotation': 90.0,
    // Because we're rotating the image, we need to swap productWidth and -Height
    'productHeight': 1216.8970189701897,
    'productWidth': 2480.0,
    'heightStrategy': 'Crop',
    'widthStrategy': 'Proportional',
  },
  {
    'id': 'TopShelf-Black_NCS_S9000N',
    'fileName': 'DoorPanel-Black_NCS_S9000N.jpg',
    'productType': 'TopShelf',
    'rotation': 90.0,
    // Because we're rotating the image, we need to swap productWidth and -Height
    'productHeight': 952.65597147950086,
    'productWidth': 2480.0,
    'heightStrategy': 'Crop',
    'widthStrategy': 'Proportional',
  },
  {
    'id': 'FrontCoverPanel-BirchMelamine',
    'fileName': 'FrontCoverPanel-BirchMelamine.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-BirchVeneer',
    'fileName': 'FrontCoverPanel-BirchVeneer.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-CherryVeneer',
    'fileName': 'FrontCoverPanel-CherryVeneer.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-OakMelamine',
    'fileName': 'FrontCoverPanel-OakMelamine.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-OakVeneer',
    'fileName': 'FrontCoverPanel-OakVeneer.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-PineVeneer',
    'fileName': 'FrontCoverPanel-PineVeneer.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-PineWood',
    'fileName': 'FrontCoverPanel-PineWood.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 1184.2105263157894,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-PineWoodProvence',
    'fileName': 'FrontCoverPanel-PineWoodProvence.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'FrontCoverPanel-WhiteMelamine',
    'fileName': 'FrontCoverPanel-WhiteMelamine.jpg',
    'productType': 'CoverPanel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 2500.0,
    'productHeight': 100.0
  },
  {
    'id': 'OnyxDoorStile-BirchVeneer',
    'fileName': 'OnyxDoorStile-BirchVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 65.0,
    'productHeight': 1966.5079365079364
  },
  {
    'id': 'OnyxDoorStile-CherryVeneer',
    'fileName': 'OnyxDoorStile-CherryVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 65.0,
    'productHeight': 1969.5355191256831
  },
  {
    'id': 'OnyxDoorStile-OakVeneer',
    'fileName': 'OnyxDoorStile-OakVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 65.0,
    'productHeight': 1967.9787234042553
  },
  {
    'id': 'OnyxDoorStile-WhiteMelamine',
    'fileName': 'OnyxDoorStile-WhiteMelamine.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 65.0,
    'productHeight': 1968.2275132275136
  },
  {
    'id': 'OpalDoorRail-BirchVeneer',
    'fileName': 'OpalDoorRail-BirchVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 748.7697160883281,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-CherryVeneer',
    'fileName': 'OpalDoorRail-CherryVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 748.84012539184948,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-OakVeneer',
    'fileName': 'OpalDoorRail-OakVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 748.81987577639745,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-PineVeneer',
    'fileName': 'OpalDoorRail-PineVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 724.90773067331679,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-PineWood',
    'fileName': 'OpalDoorRail-PineWood.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 626.41148325358847,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-PineWoodLacker',
    'fileName': 'OpalDoorRail-PineWoodLacker.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 725.86533665835418,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-PineWoodProvence',
    'fileName': 'OpalDoorRail-PineWoodProvence.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 626.37236084452968,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorRail-WhiteMelamine',
    'fileName': 'OpalDoorRail-WhiteMelamine.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 710.29712615684366,
    'productHeight': 240.0
  },
  {
    'id': 'OpalDoorStile-BirchVeneer',
    'fileName': 'OpalDoorStile-BirchVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 1965.5172413793105
  },
  {
    'id': 'OpalDoorStile-CherryVeneer',
    'fileName': 'OpalDoorStile-CherryVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 1967.0270270270271
  },
  {
    'id': 'OpalDoorStile-OakVeneer',
    'fileName': 'OpalDoorStile-OakVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 1967.1428571428573
  },
  {
    'id': 'OpalDoorStile-PineVeneer',
    'fileName': 'OpalDoorStile-PineVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 2593.6196319018404
  },
  {
    'id': 'OpalDoorStile-PineWood',
    'fileName': 'OpalDoorStile-PineWood.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 1967.25
  },
  {
    'id': 'OpalDoorStile-PineWoodLacker',
    'fileName': 'OpalDoorStile-PineWoodLacker.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 1967.1428571428573
  },
  {
    'id': 'OpalDoorStile-PineWoodProvence',
    'fileName': 'OpalDoorStile-PineWoodProvence.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 60.0,
    'productHeight': 2653.5849056603774
  },
  {
    'id': 'OpalDoorStile-WhiteMelamine',
    'fileName': 'OpalDoorStile-WhiteMelamine.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 60.0,
    'productHeight': 1967.1951219512196
  },
  {
    'id': 'OpalDualHDivider-BirchVeneer',
    'fileName': 'OpalDualHDivider-BirchVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 599.89561586638831,
    'productHeight': 70.0
  },
  {
    'id': 'OpalDualHDivider-CherryVeneer',
    'fileName': 'OpalDualHDivider-CherryVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 599.77272727272725,
    'productHeight': 70.0
  },
  {
    'id': 'OpalDualHDivider-OakVeneer',
    'fileName': 'OpalDualHDivider-OakVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 599.93684210526317,
    'productHeight': 70.0
  },
  {
    'id': 'OpalDualHDivider-WhiteMelamine',
    'fileName': 'OpalDualHDivider-WhiteMelamine.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 599.91489361702133,
    'productHeight': 70.0
  },
  {
    'id': 'OpalMultiHDivider-BirchVeneer',
    'fileName': 'OpalMultiHDivider-BirchVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'OpalMultiHDivider-CherryVeneer',
    'fileName': 'OpalMultiHDivider-CherryVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'OpalMultiHDivider-OakVeneer',
    'fileName': 'OpalMultiHDivider-OakVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'OpalMultiHDivider-WhiteMelamine',
    'fileName': 'OpalMultiHDivider-WhiteMelamine.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SafirBottomDoorRail-BlackAluminum',
    'fileName': 'SafirBottomDoorRail-BlackAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SafirBottomDoorRail-BrassAluminum',
    'fileName': 'SafirBottomDoorRail-BrassAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SafirBottomDoorRail-NaturalAluminum',
    'fileName': 'SafirBottomDoorRail-NaturalAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 471.18055555555554,
    'productHeight': 50.0
  },
  {
    'id': 'SafirBottomDoorRail-WhiteAluminum',
    'fileName': 'SafirBottomDoorRail-WhiteAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SafirDoorStile-BlackAluminum',
    'fileName': 'SafirDoorStile-BlackAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 361.41176470588232
  },
  {
    'id': 'SafirDoorStile-BrassAluminum',
    'fileName': 'SafirDoorStile-BrassAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 72.5
  },
  {
    'id': 'SafirDoorStile-NaturalAluminum',
    'fileName': 'SafirDoorStile-NaturalAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 370.12048192771084
  },
  {
    'id': 'SafirDoorStile-WhiteAluminum',
    'fileName': 'SafirDoorStile-WhiteAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 30.0,
    'productHeight': 353.10344827586209
  },
  {
    'id': 'SafirTopDoorRail-BlackAluminum',
    'fileName': 'SafirTopDoorRail-BlackAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 336.23880597014931,
    'productHeight': 22.0
  },
  {
    'id': 'SafirTopDoorRail-BrassAluminum',
    'fileName': 'SafirTopDoorRail-BrassAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 576.58895705521479,
    'productHeight': 22.0
  },
  {
    'id': 'SafirTopDoorRail-NaturalAluminum',
    'fileName': 'SafirTopDoorRail-NaturalAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 309.50684931506851,
    'productHeight': 22.0
  },
  {
    'id': 'SafirTopDoorRail-WhiteAluminum',
    'fileName': 'SafirTopDoorRail-WhiteAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 574.548780487805,
    'productHeight': 22.0
  },
  {
    'id': 'SideWall-AntrasiteMelamine',
    'fileName': 'SideWall-AntrasiteMelamine.jpg',
    'productType': 'SideWall',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 698.1497279011619,
    'productHeight': 2480.0
  },
  {
    'id': 'SideWall-PineWood',
    'fileName': 'SideWall-PineWood.jpg',
    'productType': 'SideWall',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 709.24655526238644,
    'productHeight': 2480.0
  },
  {
    'id': 'SideWall-PineWoodLacker',
    'fileName': 'SideWall-PineWoodLacker.jpg',
    'productType': 'SideWall',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 698.95539906103284,
    'productHeight': 2480.0
  },
  {
    'id': 'SideWall-PineWoodProvence',
    'fileName': 'SideWall-PineWoodProvence.jpg',
    'productType': 'SideWall',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 708.83200941453367,
    'productHeight': 2480.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Asur-BronzeSteel',
    'fileName': 'SlidingDoorBottomTrack-Asur-BronzeSteel.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 604.46511627906966,
    'productHeight': 6.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Asur-SilverSteel',
    'fileName': 'SlidingDoorBottomTrack-Asur-SilverSteel.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 6.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Asur-WhiteSteel',
    'fileName': 'SlidingDoorBottomTrack-Asur-WhiteSteel.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 6.0
  },
  {
    'id': 'SlidingDoorBottomTrack-OneRail-BlackAluminum',
    'fileName': 'SlidingDoorBottomTrack-OneRail-BlackAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 650.0,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-OneRail-BrassAluminum',
    'fileName': 'SlidingDoorBottomTrack-OneRail-BrassAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 650.0,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-OneRail-SilverAluminum',
    'fileName': 'SlidingDoorBottomTrack-OneRail-SilverAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 650.0,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-OneRail-WhiteAluminum',
    'fileName': 'SlidingDoorBottomTrack-OneRail-WhiteAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 651.66279069767438,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Safir-BlackAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-BlackAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 599.9204545454545,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Safir-BrassAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-BrassAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 599.9204545454545,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Safir-SilverAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-SilverAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 607.13095238095241,
    'productHeight': 13.0
  },
  {
    'id': 'SlidingDoorBottomTrack-Safir-WhiteAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-WhiteAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 597.45833333333337,
    'productHeight': 13.0
  },

  // Note, The triple track materials are reusing the images from the Safir track types:
  {
    'id': 'SlidingDoorBottomTrack-TripleRail-BlackAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-BlackAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 599.9204545454545,
    'productHeight': 13.0,
  },
  {
    'id': 'SlidingDoorBottomTrack-TripleRail-BrassAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-BrassAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 599.9204545454545,
    'productHeight': 13.0,
  },
  {
    'id': 'SlidingDoorBottomTrack-TripleRail-SilverAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-SilverAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 607.13095238095241,
    'productHeight': 13.0,
  },
  {
    'id': 'SlidingDoorBottomTrack-TripleRail-WhiteAluminum',
    'fileName': 'SlidingDoorBottomTrack-Safir-WhiteAluminum.jpg',
    'productType': 'BottomTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 597.45833333333337,
    'productHeight': 13.0,
  },

  {
    'id': 'SlidingDoorTopTrack-Asur-BronzeSteel',
    'fileName': 'SlidingDoorTopTrack-Asur-BronzeSteel.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SlidingDoorTopTrack-Asur-SilverSteel',
    'fileName': 'SlidingDoorTopTrack-Asur-SilverSteel.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SlidingDoorTopTrack-Asur-WhiteSteel',
    'fileName': 'SlidingDoorTopTrack-Asur-WhiteSteel.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 50.0
  },
  {
    'id': 'SlidingDoorTopTrack-ENeutral-NaturalAluminum',
    'fileName': 'SlidingDoorTopTrack-ENeutral-NaturalAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-OneRail-BlackAluminum',
    'fileName': 'SlidingDoorTopTrack-OneRail-BlackAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-OneRail-BrassAluminum',
    'fileName': 'SlidingDoorTopTrack-OneRail-BrassAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-OneRail-SilverAluminum',
    'fileName': 'SlidingDoorTopTrack-OneRail-SilverAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 599.02439024390242,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-OneRail-WhiteAluminum',
    'fileName': 'SlidingDoorTopTrack-OneRail-WhiteAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 600.0,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-Safir-BlackAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-BlackAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.14705882352939,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-Safir-BrassAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-BrassAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.21126760563379,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-Safir-SilverAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-SilverAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.23297491039432,
    'productHeight': 40.0
  },
  {
    'id': 'SlidingDoorTopTrack-Safir-WhiteAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-WhiteAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.15901060070667,
    'productHeight': 40.0
  },

  // Note, The triple track materials are reusing the images from the Safir track types:
  {
    'id': 'SlidingDoorTopTrack-TripleRail-BlackAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-BlackAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.14705882352939,
    'productHeight': 40.0,
  },
  {
    'id': 'SlidingDoorTopTrack-TripleRail-BrassAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-BrassAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.21126760563379,
    'productHeight': 40.0,
  },
  {
    'id': 'SlidingDoorTopTrack-TripleRail-SilverAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-SilverAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.23297491039432,
    'productHeight': 40.0,
  },
  {
    'id': 'SlidingDoorTopTrack-TripleRail-WhiteAluminum',
    'fileName': 'SlidingDoorTopTrack-Safir-WhiteAluminum.jpg',
    'productType': 'TopTrack',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 585.15901060070667,
    'productHeight': 40.0,
  },

  {
    'id': 'TitanBottomDoorRail-NaturalAluminum',
    'fileName': 'TitanBottomDoorRail-NaturalAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 726.76106194690283,
    'productHeight': 49.0
  },
  {
    'id': 'TitanDoorStile-NaturalAluminum',
    'fileName': 'TitanDoorStile-NaturalAluminum.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 46.0,
    'productHeight': 2529.28125
  },
  {
    'id': 'TitanTopDoorRail-NaturalAluminum',
    'fileName': 'TitanTopDoorRail-NaturalAluminum.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 713.4589371980677,
    'productHeight': 22.0
  },
  {
    'id': 'TopazDoorRail-BirchVeneer',
    'fileName': 'TopazDoorRail-BirchVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 837.92893401015237,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorRail-BlackOakPaint',
    'fileName': 'TopazDoorRail-BlackOakPaint.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 662.53521126760563,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorRail-GrayNCS_S5500N',
    'fileName': 'TopazDoorRail-GrayNCS_S5500N.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 616.92307692307691,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorRail-OakVeneer',
    'fileName': 'TopazDoorRail-OakVeneer.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 839.8779247202441,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorRail-WhiteMelamine',
    'fileName': 'TopazDoorRail-WhiteMelamine.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 831.40262361251257,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorRail-WhiteNCS_S0500N',
    'fileName': 'TopazDoorRail-WhiteNCS_S0500N.jpg',
    'productType': 'Rail',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 834.78260869565224,
    'productHeight': 120.0
  },
  {
    'id': 'TopazDoorStile-BirchVeneer',
    'fileName': 'TopazDoorStile-BirchVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 80.0,
    'productHeight': 2516.7857142857147
  },
  {
    'id': 'TopazDoorStile-BlackOakPaint',
    'fileName': 'TopazDoorStile-BlackOakPaint.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 80.0,
    'productHeight': 2749.795918367347
  },
  {
    'id': 'TopazDoorStile-GrayNCS_S5500N',
    'fileName': 'TopazDoorStile-GrayNCS_S5500N.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 80.0,
    'productHeight': 2388.5714285714284
  },
  {
    'id': 'TopazDoorStile-OakVeneer',
    'fileName': 'TopazDoorStile-OakVeneer.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 80.0,
    'productHeight': 2367.3949579831933
  },
  {
    'id': 'TopazDoorStile-WhiteMelamine',
    'fileName': 'TopazDoorStile-WhiteMelamine.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 80.0,
    'productHeight': 2175.067264573991
  },
  {
    'id': 'TopazDoorStile-WhiteNCS_S0500N',
    'fileName': 'TopazDoorStile-WhiteNCS_S0500N.jpg',
    'productType': 'Stile',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 80.0,
    'productHeight': 2206.8965517241381
  },
  {
    'id': 'TopazHDivider-BirchVeneer',
    'fileName': 'TopazHDivider-BirchVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 673.7819025522042,
    'productHeight': 100.0
  },
  {
    'id': 'TopazHDivider-BlackOakPaint',
    'fileName': 'TopazHDivider-BlackOakPaint.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 454.76190476190476,
    'productHeight': 100.0
  },
  {
    'id': 'TopazHDivider-GrayNCS_S5500N',
    'fileName': 'TopazHDivider-GrayNCS_S5500N.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 440.44943820224717,
    'productHeight': 100.0
  },
  {
    'id': 'TopazHDivider-OakVeneer',
    'fileName': 'TopazHDivider-OakVeneer.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Proportional',
    'heightStrategy': 'Crop',
    'productWidth': 383.83838383838383,
    'productHeight': 100.0
  },
  {
    'id': 'TopazHDivider-WhiteNCS_S0500N',
    'fileName': 'TopazHDivider-WhiteNCS_S0500N.jpg',
    'productType': 'Divider',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 406.18556701030923,
    'productHeight': 100.0
  },
  {
    'id': 'VulcanGrayMelamine',
    'fileName': 'VulcanGrayMelamine.jpg',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 1218.0,
    'productHeight': 248.0
  },
  {
    'id': 'WhiteEmbossedReed',
    'fileName': 'DoorPanel-WhiteEmbossedReed.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 954.950994950995,
    'productHeight': 2480.0,
  },
  {
    'id': 'BlackOakPaint',
    'fileName': 'DoorPanel-BlackOakPaint.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 949.52905198776762,
    'productHeight': 2480.0
  },
  {
    'id': 'WhiteMelamine',
    'fileName': 'DoorPanel-WhiteMelamine.jpg',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'WhiteMelamineReed',
    'fileName': 'DoorPanel-WhiteMelamineReed.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 957.1606771606771,
    'productHeight': 2480.0,
  },
  {
    'id': 'WhiteNCS_S0500N',
    'fileName': 'DoorPanel-WhiteNCS_S0500N.jpg',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
    {
    'id': 'BirchVeneer',
    'fileName': 'DoorPanel-BirchVeneer.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'Black_NCS_S9000N',
    'fileName': 'DoorPanel-Black_NCS_S9000N.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 952.65597147950086,
    'productHeight': 2480.0,
  },
  {
    'id': 'CottagePine',
    'fileName': 'DoorPanel-CottagePine.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 965.83397982932513,
    'productHeight': 2480.0,
  },
  {
    'id': 'LavaElm',
    'fileName': 'DoorPanel-LavaElm.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 958.13809154383239,
    'productHeight': 2480.0,
  },
  {
    'id': 'LightGreyXT',
    'fileName': 'DoorPanel-LightGreyXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 785.357715752326,
    'productHeight': 2280.0
  },
  {
    'id': 'HorizonXT',
    'fileName': 'DoorPanel-HorizonXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 613.89503862387517,
    'productHeight': 2280.0
  },
  {
    'id': 'Powder',
    'fileName': 'DoorPanel-Powder.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 576.4798118384947,
    'productHeight': 2280.0
  },
  {
    'id': 'CashmereXT',
    'fileName': 'DoorPanel-CashmereXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 617.60190703218109,
    'productHeight': 2280.0
  },
  {
    'id': 'VolcanicBlackXT',
    'fileName': 'DoorPanel-VolcanicBlackXT.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'productWidth': 586.99728910859517,
    'productHeight': 2280.0
  },
  {
    'id': 'ClearGlass',
    'fileName': 'DoorPanel-ClearGlass.jpg',
    'productType': 'Panel',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1210.0062695924767,
    'productHeight': 1608.3000000000002
  },
  {
    'id': 'Lavender_NCS_S1020N_R40B',
    'fileName': 'DoorPanel-Lavender_NCS_S1020N_R40B.jpg',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1018.488733972364,
    'productHeight': 2480.0,
  },
  {
    'id': 'LightGrayReed',
    'fileName': 'DoorPanel-LightGrayReed.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 947.23558313938452,
    'productHeight': 2480.0,
  },
  {
    'id': 'ManhattanGrayMelamine',
    'fileName': 'DoorPanel-ManhattanGrayMelamine.jpg',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1240.0,
    'productHeight': 2480.0,
  },
  {
    'id': 'OakReed',
    'fileName': 'DoorPanel-OakReed.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 960.70907194994788,
    'productHeight': 2480.0,
  },
  {
    'id': 'OakVeneer',
    'fileName': 'DoorPanel-OakVeneer.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'BirchVeneer',
    'fileName': 'DoorPanel-BirchVeneer.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'OakWhiteMelamine',
    'fileName': 'DoorPanel-OakWhiteMelamine.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'OakWhiteVeneer',
    'fileName': 'DoorPanel-OakWhiteVeneer.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 1200.4670472236637,
    'productHeight': 3300.0
  },
  {
    'id': 'PrimedFoil',
    'fileName': 'DoorPanel-WhiteMelamine.jpg',
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'productWidth': 1216.8970189701897,
    'productHeight': 2480.0,
  },
  {
    'id': 'SanRemoSandOak',
    'fileName': 'DoorPanel-SanRemoSandOak.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 953.9694853891906,
    'productHeight': 2480.0,
  },
  {
    'id': 'StoneAsh',
    'fileName': 'DoorPanel-StoneAsh.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 959.73931178310738,
    'productHeight': 2480.0,
  },
  {
    'id': 'Taupe_NCS_S6005_Y20R',
    'fileName': 'DoorPanel-Taupe_NCS_S6005_Y20R.jpg',
    'widthStrategy': 'Crop',
    'heightStrategy': 'Proportional',
    'productWidth': 969.236031927024,
    'productHeight': 2480.0,
  },
  {
    'id': 'FlexiBasketAndTracks-SilverSteel',
    'color': '#C0C0C0',
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'FlexiBasketAndTracks-WhiteSteel',
    'color': '#FFFFFF',
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'FlexiBasketAndTracks-BlackSteel',
    'color': '#000000',
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'MeshBasketAndTracks-SilverSteel',
    'fileName': 'MeshBasket-SilverSteel.png', // For the mesh pattern
    'hasAlpha': true,
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'color': '#C0C0C0', // For the rim
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'MeshBasketAndTracks-WhiteSteel',
    'fileName': 'MeshBasket-WhiteSteel.png',
    'hasAlpha': true,
    'widthStrategy': 'Cover',
    'heightStrategy': 'Cover',
    'color': '#FFFFFF',
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'MeshBasketAndTracks-BlackSteel',
    'fileName': 'MeshBasket-BlackSteel.png',
    'hasAlpha': true,
    'widthStrategy': 'Fill',
    'heightStrategy': 'Fill',
    'color': '#000000',
    'specularColor': '#000000', // To reduce glare on the thin wires
  },
  {
    'id': 'SilverSteel',
    'color': '#C0C0C0',
  },
  {
    'id': 'WhiteSteel',
    'color': '#FFFFFF',
  },
  {
    'id': 'BlackSteel',
    'color': '#000000',
  },
];